document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.top-label').forEach((button) => {
      button.addEventListener('mouseover', function(e) {
          e.preventDefault();
          console.log(this);
          document.querySelector('.top-label.active').classList.remove('active');
          if (this.classList.contains('active')) {
              this.classList.remove('active');
          } else {
              this.classList.add('active');
          }
      })
  })
})